export default __webpack_public_path__ + "static/media/circle-cropped.fd9f5fa7.png";